var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDifferentPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 0C2.39316 0 0 2.25184 0 5.01838C0 6.11471 0.366496 7.15441 1.06393 8.02684L5.00513 13.0221C5.01607 13.0349 5.02974 13.0375 5.04068 13.0504C5.23761 13.2485 5.52205 13.1996 5.66154 13.0221C6.79658 11.5963 8.87521 8.93529 9.67658 7.93162L9.68205 7.92647C10.3275 7.07463 10.6667 6.07096 10.6667 5.02096C10.6667 2.25184 8.2735 0 5.33333 0ZM5.33333 7.72574C3.74974 7.72574 2.45607 6.50846 2.45607 5.01838C2.45607 3.52831 3.74974 2.31103 5.33333 2.31103C6.91692 2.31103 8.2106 3.52831 8.2106 5.01838C8.2106 6.50846 6.91692 7.72574 5.33333 7.72574Z",
    fill: "#546587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 0C10.1006 0 9.55356 0.0849265 9.04211 0.239338C9.92826 0.751471 10.6558 1.48235 11.1426 2.34963C12.5019 2.56324 13.544 3.68272 13.544 5.01838C13.544 6.41324 12.4117 7.56875 10.9703 7.71029C10.8992 7.82096 10.8226 7.93162 10.7406 8.03971L10.7351 8.04743V8.05C10.2811 8.62132 9.44689 9.68419 8.57715 10.7882L10.3385 13.0221C10.3495 13.0349 10.3631 13.0375 10.3741 13.0504C10.571 13.2485 10.8554 13.1996 10.9949 13.0221C12.13 11.5963 14.2086 8.93529 15.01 7.93162L15.0154 7.92647C15.6609 7.07463 16.0001 6.07096 16.0001 5.02096C16.0001 2.25184 13.6069 0 10.6667 0Z",
    fill: "#546587"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 13.1765,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferentPoint);
export default __webpack_public_path__ + "static/media/different_point.7312d4510a3e89e9d5f8932fe8b0947c.svg";
export { ForwardRef as ReactComponent };